import { takeLatest, call, put } from 'redux-saga/effects'
import removeProfileBulkAction from 'api/administration/participants/RemoveProfilesBulkAction'
import * as fromActions from '../../actions/participants.action'

async function removeProfiles(ids: number[]) {
  return removeProfileBulkAction(ids)
}

function* participantsRemoveProfilesEffectSaga(action: any) {
  try {
    const { ids, listConfig } = action.payload
    yield call(removeProfiles, ids)
    yield put(fromActions.Actions.participantsProfilesList(listConfig))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* participantsRemoveProfilesWatcherSaga() {
  yield takeLatest(
    fromActions.REMOVE_PROFILES_BULK_ACTION,
    participantsRemoveProfilesEffectSaga
  )
}
